document.addEventListener('DOMContentLoaded',()=>{
  const menu=document.querySelector('[data-rx-menu]');
  const nav=document.querySelector('[data-rx-nav]');
  if(menu && nav){
    menu.addEventListener('click',()=>{
      nav.classList.toggle('is-open');
      const open=nav.classList.contains('is-open');
      nav.style.display=open?'flex':'none';
      menu.setAttribute('aria-expanded', open ? 'true' : 'false');
      nav.style.position='absolute';
      nav.style.left='0';nav.style.right='0';nav.style.top='74px';
      nav.style.background='var(--rx-green)';
      nav.style.padding='20px';
      nav.style.flexDirection='column';
    });
  }
});
document.addEventListener('DOMContentLoaded',()=>{
  const sticky=document.querySelector('.rx-mobile-buy a[href="#shop-product"]');
  const form=document.querySelector('.rx-product-page .rx-form');
  if(sticky && form){
    sticky.addEventListener('click',(e)=>{
      e.preventDefault();
      form.scrollIntoView({behavior:'smooth',block:'center'});
    });
  }
});
